import { render, staticRenderFns } from "./Speakers.vue?vue&type=template&id=b8571876&"
import script from "./Speakers.vue?vue&type=script&lang=js&"
export * from "./Speakers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports